import { CommonErrorCode } from '../helpers/ErrorCodes';
import { L10n } from '../L10n/L10n';
import { IDataAlertBase } from '../models/IDataAlertInfo';
import { IErrorItem } from '../../commonInfra/contentActions/MultipleItemResult';
import { Module } from '../Module';
import { IErrorDetail } from '../../commonInfra/contentActions/ActionMessages';

export class DataAlertErrors {

  public static $inject = ['$translate'];

  constructor(
    private $translate: ng.translate.ITranslateService) { }

  public errorDetailFor(errorItem: IErrorItem<IDataAlertBase>): IErrorDetail {
    const itemName = errorItem.item.name;
    let errorMessage: string;

    switch (errorItem.error.code) {
      case CommonErrorCode.DataAlertNotFound:
        errorMessage = this.$translate.instant('errorDataAlertNotFound', { ALERT_NAME: L10n.elideIfLong(itemName) });
        break;
      case CommonErrorCode.CallingUserInsufficientPermissions:
        errorMessage = this.$translate.instant('errorDataAlertInsufficientPermissions', { ALERT_NAME: L10n.elideIfLong(itemName) });
        break;
      case CommonErrorCode.SiteUserNotFound:
        errorMessage = this.$translate.instant('errorUserNotFound', { ALERT_NAME: L10n.elideIfLong(itemName) });
        break;
      default:
        errorMessage = this.$translate.instant('errorUnknown');
    }

    return { itemName, errorMessage };
  }
}

Module.instance().service('DataAlertErrors', DataAlertErrors);
